import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import axiosInstance from '../utils/axios';
import OrganizationForm from './OrganizationForm';  // Import the form component

const OrganizationDialog = ({ inputEntity, open, onClose, onSubmit, simpleMode = false }) => {
    const [entity, setEntity] = useState({ name: '', description: '', status: 'ACTIVE', type: '', primaryContactId:'' });
    const [dialogTitle, setDialogTitle] = useState('');

    useEffect(() => {
        console.log("in OrganizationDialog useEffect...")
        console.log(inputEntity)
        let title = "Configure New ";
        let displayOrgType = "Organization";

        if (inputEntity) {
            setEntity(inputEntity);
            title = inputEntity.id ? "Edit " : title;
        }

        setDialogTitle(title + displayOrgType);
    }, [inputEntity, simpleMode]);

    const handleFormChange = (updatedEntity) => {
        setEntity(updatedEntity);
    };

    const handleSave = async () => {
        try {
            if (entity.id) {
                // Update the organization
                await axiosInstance.put(`organizations/${entity.id}/`, entity);
            } else {
                // Create a new organization
                await axiosInstance.post('organizations/', entity);
            }
            onSubmit();  // Call onSubmit after successfully saving
        } catch (error) {
            console.error('Error saving organization', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
                {entity != null && (
                    <OrganizationForm inputEntity={entity} onChange={handleFormChange} simpleMode={simpleMode} />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OrganizationDialog;
